<template>
    <div>
        <div v-if="model && model.containers">
            <b></b>
            <div class="card mb-4" v-for="container in model.containers" :key="container.contrainerId">
                <div class="card-header">{{isEnVersion ? container.containerLabelEn : container.containerLabel}}</div>
                <div class="card-body">
                    <div class="row">
                        <div class="form-group col-md-6 com-sm-12" v-for="field in container.fields" :key="field.fieldValueId">
                            <label class="font-weight-bold" :for="field.fieldId + '_field'">{{isEnVersion ? field.fieldLabelEn : field.fieldLabel}}</label>
                            <div v-if="field.fieldType === 'Datepicker'">
                                <i v-if="field.datetimeValue" class="far fa-clock"></i>
                                <span :id="field.fieldId + '_field'"
                                      :aria-describedby="field.fieldId + '_description'">
                                    {{field.datetimeValue ? moment(field.datetimeValue).format('DD.MM.YYYY HH:mm:ss') : ''}}
                                </span>
                                <small v-if="field.datetimeValue" :id="field.fieldId + '_description'" class="form-text text-muted">{{isEnVersion ? field.descriptionEn : field.description}}</small>
                            </div>
                            <div v-else>
                                <span :id="field.fieldId + '_field'"
                                      :aria-describedby="field.fieldId + '_description'">
                                    {{isEnVersion ? field.stringValueEn : field.stringValue}}
                                </span>
                                <small v-if="field.stringValue" :id="field.fieldId + '_description'" class="form-text text-muted">{{isEnVersion ? field.descriptionEn : field.description}}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
    import moment from 'moment'
    import { DynamicFormDetails } from '../../../models/models';
    import { mapGetters } from 'vuex'

    export default {
        props: {
            value: {
                type: [DynamicFormDetails, Object],
                required: false
            },
        },
        data() {
            return {
                model: this.value,
                moment: moment
            }
        },
        methods: {
            onCancel() {
                this.$emit("cancel");
            },
        },
        computed: {
            ...mapGetters(['isEnVersion'])
        },
        watch: {
            value: function (val) {
                if (val) {
                    this.model = new DynamicFormDetails(this.value);
                }
            }
        }
    }
</script>

